// Sitenin herkese açık takip kanalları (ana sayfa slider'ı ve indirim detay sayfaları kullanır)
export const TELEGRAM_KANAL = "https://t.me/indirimuzmanicom";
export const WHATSAPP_KANAL = "https://whatsapp.com/channel/0029VbAeEdU1Hsq5YIttUc2c";
export const INSTAGRAM_HESABI = "https://www.instagram.com/indirimuzmanicom/";
